window.PRCart = (function () {
  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function updateCountBubbles(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    if (count === null) return;
    document
      .querySelectorAll('[data-cart-count], .cart-count-bubble, [class*="cart-count" i], .cart-bubble__text-count')
      .forEach(function (el) {
        if (el.tagName === 'INPUT') return;
        el.textContent = count;
        el.hidden = count === 0;
      });
  }

  // Task 2 (cart delay fix): the theme's own header cart icon (<cart-icon>, assets/cart-icon.js)
  // and drawer (<cart-items-component>, assets/component-cart-items.js) both listen for the
  // native `cart:update` event (ThemeEvents.cartUpdate, see assets/events.js) and read
  // `event.detail.data.itemCount` / `event.detail.data.sections`. This used to dispatch plain
  // CustomEvents with `detail: { cart }` — no `data` key at all — so cart-icon read
  // `itemCount` as 0 (blanking the header bubble instead of updating it) and cart-items-component
  // threw reading `.sections` off `undefined`, so the drawer never refreshed. Both only ever
  // caught up on the next full page load, which is the "delay" this fixes: dispatch the event
  // in the shape those listeners actually expect. With `data.sections` absent (we don't have
  // pre-rendered section HTML here), cart-items-component falls back to its own
  // `sectionRenderer.renderSection(...)` re-fetch, so the drawer still ends up correct.
  function nudgeThemeCart(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'pr-cart', data: { itemCount: cart.item_count } },
      }));
    } catch (e) {}
    try {
      // The theme's cart drawer custom element is <cart-drawer-component> (assets/cart-drawer.js),
      // not <cart-drawer> — the old selector never matched anything, so this call was a no-op.
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    } catch (e) {}
  }

  var toastTimer = null;
  function toast(message, isError) {
    var el = document.getElementById('pr-cart-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'pr-cart-toast';
      el.className = 'pr-cart-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.toggle('pr-cart-toast--error', !!isError);
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  function add(items, opts) {
    opts = opts || {};
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          var message = (result.data && result.data.description) || 'לא הצלחנו להוסיף את המארז לעגלה.';
          if (!opts.silentToast) toast(message, true);
          return { ok: false, error: message };
        }
        return fetchCart().then(function (cart) {
          updateCountBubbles(cart);
          nudgeThemeCart(cart);
          if (!opts.silentToast) toast(opts.successMessage || '✓ המארז נוסף לעגלה');
          return { ok: true, cart: cart };
        });
      })
      .catch(function (err) {
        if (!opts.silentToast) toast('שגיאת רשת — נסו שוב.', true);
        return { ok: false, error: err };
      });
  }

  return { add: add, toast: toast, fetchCart: fetchCart };
})();
